import React, { useState } from 'react';

interface PreviewData {
    categories: { name: string }[];
    subcategories: { name: string; categoryName: string }[];
    items: any[];
}

const AdminImport: React.FC = () => {
    const [tenantId, setTenantId] = useState<string>(() => localStorage.getItem('tenantId') || '');
    const [file, setFile] = useState<File | null>(null);
    const [preview, setPreview] = useState<PreviewData | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [commitResult, setCommitResult] = useState<any>(null);

    const uploadPrepare = async () => {
        if (!file || !tenantId) { setError('File o tenant mancante'); return; }
        setError(null); setLoading(true); setCommitResult(null);
        try {
            const form = new FormData();
            form.append('file', file);
            const res = await fetch(`/api/menus/${tenantId}/bulk-prepare`, { method: 'POST', body: form });
            const json = await res.json();
            if (!res.ok) throw new Error(json.error || 'Errore prepare');
            setPreview(json);
        } catch (e: any) {
            setError(e.message);
        } finally { setLoading(false); }
    };

    const commit = async () => {
        if (!preview || !tenantId) return;
        setLoading(true); setError(null);
        try {
            const body = JSON.stringify({
                categories: preview.categories,
                subcategories: preview.subcategories,
                items: preview.items
            });
            const res = await fetch(`/api/menus/${tenantId}/bulk-commit`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body });
            const json = await res.json();
            if (!res.ok) throw new Error(json.error || 'Errore commit');
            setCommitResult(json);
        } catch (e: any) {
            setError(e.message);
        } finally { setLoading(false); }
    };

    return (
        <div style={{ padding: 24, maxWidth: 1200, margin: '0 auto', fontFamily: 'sans-serif' }}>
            <h1>Import Menu (Admin)</h1>
            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                <div style={{ minWidth: 260 }}>
                    <label>Tenant ID</label>
                    <input value={tenantId} onChange={e => { setTenantId(e.target.value); localStorage.setItem('tenantId', e.target.value); }} style={{ width: '100%', marginBottom: 8 }} />
                    <input type="file" onChange={e => setFile(e.target.files?.[0] || null)} accept=".csv,.tsv,.txt,.pdf" />
                    <button onClick={uploadPrepare} disabled={loading || !file} style={{ marginTop: 8 }}>1. Prepare</button>
                    <button onClick={commit} disabled={loading || !preview} style={{ marginTop: 8 }}>2. Commit</button>
                    {loading && <div style={{ marginTop: 8 }}>Loading...</div>}
                    {error && <div style={{ marginTop: 8, color: '#c62828' }}>{error}</div>}
                    {commitResult && (
                        <div style={{ marginTop: 12, background: '#e8f5e9', padding: 8, borderRadius: 6, fontSize: 12 }}>
                            <strong>Commit OK</strong>
                            <pre style={{ whiteSpace: 'pre-wrap' }}>{JSON.stringify(commitResult, null, 2)}</pre>
                        </div>
                    )}
                </div>
                <div style={{ flex: 1, minWidth: 300 }}>
                    {preview ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                            <section>
                                <h3>Categorie ({preview.categories.length})</h3>
                                <ul style={{ margin: 0, paddingLeft: 18 }}>
                                    {preview.categories.map(c => <li key={c.name}>{c.name}</li>)}
                                </ul>
                            </section>
                            <section>
                                <h3>Sottocategorie ({preview.subcategories.length})</h3>
                                <ul style={{ margin: 0, paddingLeft: 18 }}>
                                    {preview.subcategories.map((s, i) => <li key={i}>{s.categoryName} → {s.name}</li>)}
                                </ul>
                            </section>
                            <section>
                                <h3>Items ({preview.items.length})</h3>
                                <div style={{ maxHeight: 320, overflow: 'auto', border: '1px solid #eee', borderRadius: 6 }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                                        <thead>
                                            <tr style={{ background: '#fafafa' }}>
                                                <th style={th}>Cat</th><th style={th}>Sub</th><th style={th}>Nome</th><th style={th}>Prezzo</th><th style={th}>Allergeni</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {preview.items.map((it, i) => (
                                                <tr key={i}>
                                                    <td style={td}>{it.category}</td>
                                                    <td style={td}>{it.subcategory}</td>
                                                    <td style={td}>{it.name}</td>
                                                    <td style={td}>{it.price}</td>
                                                    <td style={td}>{Array.isArray(it.allergens) ? it.allergens.join(', ') : ''}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </section>
                        </div>
                    ) : (
                        <div style={{ color: '#777', fontSize: 14 }}>Carica un file e premi "Prepare" per vedere l'anteprima.</div>
                    )}
                </div>
            </div>
        </div>
    );
};

const th: React.CSSProperties = { textAlign: 'left', padding: '4px 6px', borderBottom: '1px solid #ddd', position: 'sticky', top: 0 };
const td: React.CSSProperties = { padding: '4px 6px', borderBottom: '1px solid #f0f0f0' };

export default AdminImport;
